import { cn } from "@/utils/cn";

interface SelectableChipProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const SelectableChip = ({
  label,
  selected,
  onClick,
  disabled = false,
}: SelectableChipProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "relative h-[38px] shrink-0 rounded-[68px] border px-4 py-2 text-sm font-medium whitespace-nowrap overflow-hidden overflow-ellipsis",
        "disabled:cursor-not-allowed disabled:opacity-60",
        selected
          ? "border-[#ff008c] bg-[#ff008c] text-white"
          : [
              "border-purple-700 bg-white text-purple-700",
              "shadow-[inset_0_-12px_6px_0_rgba(98,10,213,0.06)]",
            ],
      )}
    >
      {label}
    </button>
  );
};
